import React from "react";

const ShortStair = () => {
    return (
        <svg width="57" height="87" viewBox="0 0 57 87" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M55.0006 72.1602H2.07031V84.4058H55.0006V72.1602Z" stroke="#4A5353" stroke-width="4" stroke-miterlimit="10" />
            <path d="M55.0006 59.9141H2.07031V72.1597H55.0006V59.9141Z" stroke="#4A5353" stroke-width="4" stroke-miterlimit="10" />
            <path d="M55.0006 47.6699H2.07031V59.9155H55.0006V47.6699Z" stroke="#4A5353" stroke-width="4" stroke-miterlimit="10" />
            <path d="M55.0006 35.4238H2.07031V47.6694H55.0006V35.4238Z" stroke="#4A5353" stroke-width="4" stroke-miterlimit="10" />
            <path d="M55.0006 23.1758H2.07031V35.4214H55.0006V23.1758Z" stroke="#4A5353" stroke-width="4" stroke-miterlimit="10" />
            <path d="M55 2H2V23H55V2Z" stroke="#4A5353" stroke-width="4" stroke-miterlimit="10" />
        </svg>
    )
}
export default ShortStair;